/* eslint-disable */
import Scrollbar from 'smooth-scrollbar'
// import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar'
import r1 from './r1.js'
import c11 from './c11.js'

// class ModalPlugin extends ScrollbarPlugin {
//   static pluginName = 'modal'

//   static defaultOptions = {
//     open: false
//   }

//   transformDelta (delta) {
//     return this.options.open ? { x: 0, y: 0 } : delta
//   }
// }

// Scrollbar.use(ModalPlugin /* OverscrollPlugin */)

var i = function () {
  function i(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, i),
      this.scroll = this.scroll.bind(this),
      Scrollbar && (this.root = e.container,
        this.root && (this.views = []))
  }
  return r1(i, [{
    key: "scroll",
    value: function (e) {
      window.currentScrollTop = e.offset.y
        // window.currentScrollDirection = e.direction.y;
      for (var t = 0; t < this.views.length; t++)
        this.views[t].fn(e)
    }
  }], [{
    key: "init",
    value: function (e) {
      var t = i.instance;
      window.currentScrollTop = 0,
        window.scrollBar = Scrollbar.init(t.root, e),
        window.scrollBar.addListener(t.scroll)
    }
  }, {
    key: "debug",
    value: function () { }
  }, {
    key: "start",
    value: function (e) {
      window.currentScrollTop = 0;
      var t = {
        container: document.querySelector("#wrap"),
        alwaysShowTracks: !0,
        syncCallbacks: !0
      }
        , n = (0,
          c11.merge)(t, e);
      i.instance = new i(n),
        i.init(n)
    }
  }, {
    key: "bind",
    value: function (e, t) {
      i.instance.views.push({
        id: e,
        fn: t
      })
    }
  }, {
    key: "unbind",
    value: function (e) {
      for (var t = i.instance, n = 0; n < t.views.length; n++)
        if (t.views[n].id === e) {
          t.views.splice(n, 1);
          break
        }
    }
  }]),
    i
}();
// var t = { default: i }

export default i
